import React, { Component } from 'react';
import update from 'immutability-helper';
import { DragSource, DropTarget } from 'react-dnd';

import { rowTarget, rowSource, addDndContext } from '../../utils/dndHelpers';
import { reorderHappenings } from '../../mutations';
import { HappeningCell } from '../Happenings';

class HappeningCellWrapper extends Component {
  render() {
    const { happening, isDragging, connectDragSource, connectDropTarget } =
      this.props;
    const opacity = isDragging ? 0 : 1;

    return (
      <HappeningCell
        happening={happening}
        style={{ cursor: 'move', opacity }}
        trRef={(tr) => {
          connectDragSource(tr);
          connectDropTarget(tr);
        }}
      />
    );
  }
}

const HAPPENING = 'happening';

// The following looks weird because the library (react-dnd) assumes you're using ES7 decorators
// but it seemed like overkill to adjust the compiler to make this look a little prettier.
// It's what it would compile to anyway.
const SortableHappeningCell = DropTarget(HAPPENING, rowTarget, (connect) => ({
  connectDropTarget: connect.dropTarget(),
}))(
  DragSource(HAPPENING, rowSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  }))(HappeningCellWrapper)
);

export class HappeningList extends Component {
  render() {
    const { moveRow, happenings } = this.props;
    return (
      <div>
        <table className="tables">
          <thead>
            <tr>
              <th>Title</th>
              <th>URL</th>
              <th>Start Date</th>
              <th>End Date</th>
            </tr>
          </thead>
          <tbody>
            {happenings.map((happening, i) => (
              <SortableHappeningCell
                key={happening.id}
                index={i}
                id={happening.id}
                happening={happening}
                moveRow={moveRow}
              />
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}
export default addDndContext(HappeningList);
